import axios from "axios";

export const loginFromApi = (data) =>
  axios.post('auth', data)
    .then(response => response.data)
    .catch(error => error);
